import React from 'react';
import propTypes from 'prop-types';
import { getMessage , getCropBasedMessage } from 'util/locale';
import classNames from 'classnames';
import { first, size } from 'lodash';
import { Label, Dropdown } from '@tcc/crate';
import { useSelector } from 'react-redux';
import { getActiveCropId } from 'current/currentSelectors';

// constants
import {
  scriptConfigViews,
  NITROGEN_APPLICATION_RATE_TYPES
} from 'constants/values';
import { applicationTypes } from 'constants/scripts';

// components
import ValueWithHeader from 'common/ValueWithHeader';
import ScriptConfigViewTrigger from 'triggers/ScriptConfigViewTrigger';

const baseString = 'vra-script-config-summary';
const classString = classNames({
  [`${baseString}`]: true
});


function getFirstProduct(products) {
  let product = first(products);
  if (!product) {
    product = {};
  }
  return product;
}

function getChemicalClassName(product) {
  return product.isCustom
    ? `custom-chemical-badge`
    : '';
}


const ScriptConfigSummary = ({
  applicationType,
  onClickScriptConfigViewTrigger,
  products,
  nitrogenApplicationRateType,
  showNitrogenApplicationRateTypeSwitch,
  setNitrogenApplicationRateType
}) => {
  let productHeader;
  const cropId = useSelector(getActiveCropId);

  if(size(products) > 1) {
    productHeader = (
      <span>{products.length} {getMessage('label-text__products')}</span>
    );
  } else {
    let product = getFirstProduct(products);
    productHeader = (
      <ul>
        <li>
          <ValueWithHeader
            className={getChemicalClassName(product)}
            header={
              applicationTypes.SEED === applicationType 
                ? getCropBasedMessage({ key:`product--${applicationTypes.SEED}`, cropId}) 
                : getMessage(`product--${applicationType}`)
            }
            value={product.name}
          />
          {product.isCustom && (
            <Label
              className="custom-full-badge"
              status="default"
              testId="crate-label-success-primary"
            >
              {getMessage('text__use-custom-label')}
            </Label>
          )}
        </li>
      </ul>
    );
  }

  return (

    <section className={classString}>
      {productHeader}
      <div className={`${baseString}-right`}>
        <ScriptConfigViewTrigger
          currentView={scriptConfigViews.SUMMARY}
          onClick={() =>
            onClickScriptConfigViewTrigger(scriptConfigViews.INPUTS)
          }
        />
        {/* Will only show switch if script type is nitrogen and feature flag is enabled */}
        {showNitrogenApplicationRateTypeSwitch && (
          <Dropdown
            borderless
            className="nitrogen-application-rate-type-dropdown"
            onChange={setNitrogenApplicationRateType}
            options={[
              {
                id: NITROGEN_APPLICATION_RATE_TYPES.nitrogen,
                value: getMessage(
                  `text__switch-nitrogen-application-rate-type--${NITROGEN_APPLICATION_RATE_TYPES.nitrogen}`
                )
              },
              {
                id: NITROGEN_APPLICATION_RATE_TYPES.fertilizer,
                value: getMessage(
                  `text__switch-nitrogen-application-rate-type--${NITROGEN_APPLICATION_RATE_TYPES.fertilizer}`
                )
              }
            ]}
            setValue={(_, id) => setNitrogenApplicationRateType(id)}
            testId="nitrogen-application-rate-type-dropdown"
            value={getMessage(
              `text__switch-nitrogen-application-rate-type--${nitrogenApplicationRateType}`
            )}
          />
        )}
      </div>
    </section>
  );
};
ScriptConfigSummary.propTypes = {
  applicationType: propTypes.string.isRequired,
  isCropProtectionEnabled: propTypes.bool,
  nitrogenApplicationRateType: propTypes.string,
  onClickScriptConfigViewTrigger: propTypes.func.isRequired,
  products: propTypes.array.isRequired,
  setNitrogenApplicationRateType: propTypes.func,
  showNitrogenApplicationRateTypeSwitch: propTypes.bool
};
export default ScriptConfigSummary;
